import { NumberInputField } from "@src/components/deprecated/NumberInputField/NumberInputField";
import { t } from "i18next";
import { CustomFieldDataOptions } from "../../../Property/Collections/PropertyCustomFieldData";
import { CustomFieldDataTypeHelper, DataEditorContext } from "./CustomFieldDataTypeHelper";
import styles from "./CustomFieldDateDataType.module.css";

export class CustomFieldNumberDataType extends CustomFieldDataTypeHelper<number> {
  getDataEditor(
    data: any | undefined,
    options: CustomFieldDataOptions,
    context: DataEditorContext,
    setData: (data: number | undefined) => void
  ): JSX.Element {
    return (
      <NumberInputField
        className={styles.textInput}
        placeholder={t("main.enterNumber")}
        value={typeof data === "number" ? data : undefined}
        fullWidth
        onChange={(number) => {
          if (Number.isNaN(number as any)) {
            setData(undefined);
          } else {
            setData(number);
          }
        }}
      />
    );
  }
}

